import { useQuery } from "@apollo/client";

import { ModelEnum } from "./types";
import { GET_ALL_REQUIREMENTS, GET_HCP_REQUIREMENTS } from "./gql";

// FIXME: Automatically disabled during ESLint config update
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function useRequirements(props?: any) {
  const { id, model, skip } = props || {};
  const allResult = useQuery(GET_ALL_REQUIREMENTS, {
    skip: model !== undefined || skip,
    fetchPolicy: "cache-and-network",
  });
  const hcpResult = useQuery(GET_HCP_REQUIREMENTS, {
    skip: model !== ModelEnum.HCP || skip,
    variables: { hcpId: id },
    fetchPolicy: "cache-and-network",
  });

  const data = allResult.data || hcpResult.data || {};
  const error = allResult.error || hcpResult.error;
  const loading = allResult.loading || hcpResult.loading;

  return { loading, error, data };
}
